import { createRoot } from "react-dom/client";
import { ThemeProvider, CssBaseline } from "@mui/material";
import "./styles/tokens.css";
import "./styles/base.css";
import App from "./App";
import { theme } from "./theme";
import { initAnalytics } from "./lib/analytics";
import { config } from "./config";

initAnalytics(config);

createRoot(document.getElementById("root")).render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
);
